module.exports = __webpack_public_path__ + "img/mainPage.19500010.png";